import React from 'react';
import { motion } from 'framer-motion';
import { FolderIcon, GithubIcon, ExternalLinkIcon, CodeIcon, PlayIcon } from 'lucide-react';
import { projects } from '../../data/projects';
export const ProjectsApp: React.FC = () => {
  return <div className="h-full w-full bg-[#1e1e1e] flex text-white" data-id="element-58" data-mp="11ezswu2raa11">
      {/* Sidebar */}
      <div className="w-64 bg-[#252526] border-r border-white/10 flex flex-col" data-id="element-59" data-mp="wldplsihfihw">
        <div className="p-4 text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-60" data-mp="1adbshllloi5m">
          Explorer
        </div>
        <div className="flex-1 overflow-y-auto mac-scrollbar" data-id="element-61" data-mp="16ci3eowf8xb5">
          <div className="px-2 space-y-1" data-id="element-62" data-mp="1kcsvtwddqjyf">
            <div className="flex items-center gap-2 px-2 py-1.5 bg-blue-500/20 text-blue-400 rounded cursor-pointer" data-id="element-63" data-mp="1kagenlfg4dmf">
              <FolderIcon size={16} className="fill-blue-500/20" data-id="element-64" data-mp="3m3w78nv3g2k1" />
              <span className="text-sm" data-id="element-65" data-mp="3m45y0dnyqdqs">Projects</span>
            </div>
            {projects.map(p => <div key={p.id} className="flex items-center gap-2 px-2 py-1.5 pl-6 text-gray-400 hover:text-gray-200 hover:bg-white/5 rounded cursor-pointer transition-colors" data-id="element-66" data-mp="3h6xdw7j97zmw">
                <CodeIcon size={14} data-id="element-67" data-mp="zx7rqa5euh8t" />
                <span className="text-sm truncate" data-id="element-68" data-mp="zw4yhvkm82pq">{p.id}.ts</span>
              </div>)}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-[#1e1e1e] overflow-y-auto mac-scrollbar p-8" data-id="element-69" data-mp="19n9duwe7dpl3">
        <div className="max-w-4xl mx-auto" data-id="element-70" data-mp="19pdff7omqci7">
          <div className="mb-8" data-id="element-71" data-mp="1elatt8gc18sc">
            <h1 className="text-3xl font-bold mb-2" data-id="element-72" data-mp="1ek99sehc9byh">My Projects</h1>
            <p className="text-gray-400" data-id="element-73" data-mp="1jm8crn9626uw">
              A collection of things I've built. Click{' '}
              <span className="text-emerald-400 font-medium" data-id="element-74" data-mp="1nlqyumcq4nzb">Live Demo</span> to
              try them, or{' '}
              <span className="text-gray-200 font-medium" data-id="element-75" data-mp="3ldv4xs4so7sy">View Code</span> to
              read the source.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-76" data-mp="3pfyj4oiulqhx">
            {projects.map((project, index) => <motion.div key={project.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#252526] border border-white/10 rounded-xl p-6 flex flex-col hover:-translate-y-1 hover:border-blue-500/50 transition-all duration-200 group" data-id="element-77" data-mp="rktw4i3phyik" data-mpi={index}>
                <div className="flex justify-between items-start mb-4" data-id="element-78" data-mp="1p711hu7u3uvz">
                  <div className="p-3 bg-blue-500/10 rounded-lg text-blue-400 group-hover:bg-blue-500 group-hover:text-white transition-colors" data-id="element-79" data-mp="1k8pt7nx6tsfv">
                    <FolderIcon size={24} data-id="element-80" data-mp="1y9a8ia3w964m" />
                  </div>
                  {project.liveUrl && <span className="px-2 py-1 rounded-full text-[10px] font-semibold bg-emerald-500/15 text-emerald-400 border border-emerald-500/20 flex items-center gap-1" data-id="element-81" data-mp="1t7upsop6vbpe">
                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" data-id="element-82" data-mp="2huai8nscrvtr" />
                      LIVE
                    </span>}
                </div>

                <h3 className="text-xl font-bold mb-2 group-hover:text-blue-400 transition-colors" data-id="element-83" data-mp="27vbglp6090g9">
                  {project.title}
                </h3>
                <p className="text-gray-400 text-sm mb-6 flex-1 leading-relaxed" data-id="element-84" data-mp="1yvof73d9zun7">
                  {project.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-4" data-id="element-85" data-mp="1k8d2gy5cy4li">
                  {project.tech.map(tech => <span key={tech} className="text-xs font-mono px-2 py-1 bg-black/30 text-gray-300 rounded border border-white/5" data-id="element-86" data-mp="1p6obj6ntwb2o">
                      {tech}
                    </span>)}
                </div>

                {/* Action buttons */}
                <div className="flex gap-2 mt-auto pt-2 border-t border-white/5" data-id="element-87" data-mp="135o21yhumcnq">
                  {project.liveUrl ? <a href={project.liveUrl} target="_blank" rel="noreferrer" className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg text-sm font-medium transition-all hover:-translate-y-0.5" data-id="element-88" data-mp="yefwjdjn3bfu">
                      <PlayIcon size={14} fill="currentColor" data-id="element-89" data-mp="fftsbpstt47p" />
                      Live Demo
                      <ExternalLinkIcon size={12} className="opacity-70" data-id="element-90" data-mp="bei1xi24oeyg" />
                    </a> : <div className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 bg-white/5 text-white/40 rounded-lg text-sm font-medium cursor-not-allowed" data-id="element-91" data-mp="29ue93re10flt">
                      Demo Unavailable
                    </div>}
                  {project.githubUrl && <a href={project.githubUrl} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 px-3 py-2 bg-white/5 hover:bg-white/10 text-white rounded-lg text-sm font-medium transition-all hover:-translate-y-0.5 border border-white/10" data-id="element-92" data-mp="3sofo8g23qmhy">
                      <GithubIcon size={14} data-id="element-93" data-mp="39pv3r6upufda" />
                      View Code
                    </a>}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
};